// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"460337a8","240":"0d4b9520","710":"5bfb555f","845":"46826aa6","884":"cbcf6f21","923":"d5b98221","983":"a80eea21"}[chunkId] + ".chunk.js";
};